import React, { useState } from 'react';
import { Modal, Form, Select, InputNumber, Button, message } from 'antd';
import { FilterFormValues } from '../types/main';
import { allPlatforms } from '../helpers/tableFunctions';

interface AllocationManagerFilterProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (values: FilterFormValues) => void;
  loading?: boolean;
}

const AllocationManagerFilter: React.FC<AllocationManagerFilterProps> = ({
  visible,
  onCancel,
  onOk,
  loading = false
}) => {
  const [form] = Form.useForm<FilterFormValues>();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      message.error('Please fill in the required fields');
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const currentYear = new Date().getFullYear();
  const monthOptions = Array.from({ length: 12 }, (_, i) => ({
    label: new Date(2024, i).toLocaleDateString('en-US', { month: 'long' }),
    value: i + 1
  }));

  const yearOptions = Array.from({ length: 2 }, (_, i) => ({
    label: (currentYear - 1 + i).toString(),
    value: currentYear - 1 + i
  }));

  return (
    <Modal
      title="Filter Allocation Manager"
      open={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="Fetch Data"
      cancelText="Cancel"
      okButtonProps={{ loading }}
      width={500}
      centered
      maskClosable={false}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        initialValues={{
          platform: undefined,
          month: undefined,
          year: undefined
        }}
      >
        <Form.Item
          name="platform"
          label="Platform"
          rules={[
            { required: true, message: 'Please select at least one platform' }
          ]}
        >
          <Select
            placeholder="Select platforms"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={allPlatforms.map(platform => ({
              label: platform,
              value: platform
            }))}
          />
        </Form.Item>

        <Form.Item
          name="months"
          label="Months (Optional)"
        >
          <Select
            mode="multiple"
            placeholder="Select month"
            allowClear
            options={monthOptions}
          />
        </Form.Item>

        <Form.Item
          name="years"
          label="Years (Optional)"
        >
          <Select
            mode="multiple"
            placeholder="Select year"
            allowClear
            options={yearOptions}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AllocationManagerFilter;